export enum ItemListName {
  Subscription = 'Subscription',
  SubscriptionDouble = 'Subscription Double',
  Gifting = 'Gifting',
  OTP = 'OTP'
}
